<template>
    <div class="vm-im">
        <div ref="scroll" class="message-box">
            <div class="scroll-inner-box">
                <template v-for="(dialog, $index) in dialog_current">
                    <div
                        class="message-item"
                        :msg-type="dialog.message.type"
                        :key="$index"
                        :class="{
                            'receive-box': dialog.type == 'receive',
                            'send-box': dialog.type == 'send',
                        }"
                    >
                        <div v-if="dialog.message.send_time" class="lh1 send-time fs12 black-3" @click="open_order(dialog.message.msg_id)">{{$time_show(dialog.message.send_time, "YYYY-MM-DD HH:mm:ss")}}{{dialog.work_order && dialog.work_order.tips}}</div>
                        <div class="avatar">
                            <avatar
                                v-if="this_user"
                                class="wh48"
                                :user="
                                    dialog.type == 'receive'
                                        ? this_user
                                        : session_user
                                "
                                :is_only_avatar="true"
                            ></avatar>
                        </div>

                        <div
                            v-if="
                                [1, 4, 5,7, '1', '4', '5', '7'].indexOf(
                                    dialog.message.type
                                ) != -1
                            "
                            class="msg"
                            v-html="deal_msg(dialog.message.content, dialog.message.type == 7)"
                        ></div>
                        <section
                            v-if="dialog.message.type == 2"
                            class="msg type-2 pointer"
                            @click="jump(dialog)"
                            :class="{
                                'is-has-remark': dialog.message.content.remark,
                            }"
                        >
                            <div class="leave-info">
                                <div class="fsl14">
                                    {{$t('c.Im.text1')}}
                                    {{dialog.message.content.plan && dialog.message.content.plan.name}}
                                    {{dialog.message.content.plan && dialog.message.content.plan.independent == 1 ? $t('c.Im.text2') : ""}}
                                    {{dialog.message.content.plan && !dialog.message.content.plan.plan_id ? $t('c.Im.text3') : ''}}
                                </div>
                                <div v-if="dialog.message.content.sku_detail && dialog.message.content.sku_detail.length > 0" class="mt4">
                                  <p v-for="(sku, i) in dialog.message.content.sku_detail" :key="i">{{sku.name}} * {{sku.count}}</p> 
                                </div>
                                <template v-if="dialog.message.content.pay_type != 3">
                                    <div class="fsl32 mt8">
                                      ￥{{dialog.message.content.total_amount}}
                                    </div>
                                    <div v-if="dialog.message.content.discount > 0">
                                      <s class="ml8 white-5">￥{{dialog.message.content.show_amount}}</s>
                                    </div>
                                </template>
                                <div class="fsl24 mt8" v-else>{{$t('c.Im.text4')}}</div>
                                <div class="fsl14 mt16">
                                    <template v-if="dialog.message.content.plan && dialog.message.content.plan.product_type == 0">
                                    {{
                                        dialog.message.content.pay_type == 3
                                            ? `￥${dialog.message.content.plan.price}`
                                            : `￥${dialog.message.content.per_month}`
                                    }}
                                    x {{ dialog.message.content.month }} {{$t('c.Im.text5')}}
                                    <span class="white-5" v-if="dialog.message.content.discount > 0">
                                        ({{$t('c.Im.text6')}}{{$mixin_discount(dialog.message.content.discount)}}%)
                                    </span>
                                    </template>
                                    <template v-if="dialog.message.content.is_upgrade == 1">
                                        ({{$t('c.Im.text7')}})
                                    </template>
                                </div>
                            </div>
                            <pre-box
                                v-if="dialog.message.content.remark"
                                class="leave-word"
                                :text="dialog.message.content.remark"
                            ></pre-box>
                            <div v-if="dialog.message.content.ext && dialog.message.content.ext.address && (dialog.message.content.ext.address.name || dialog.message.content.ext.address.phone || dialog.message.content.ext.address.address)" class="black-8 leave-word">
                              <p v-if="dialog.message.content.ext.address.name">{{dialog.message.content.ext.address.name}}</p>
                              <p v-if="dialog.message.content.ext.address.phone">{{dialog.message.content.ext.address.phone}}</p>
                              <p v-if="dialog.message.content.ext.address.address">{{dialog.message.content.ext.address.address}}</p>
                            </div>
                        </section>
                        <section
                            v-if="dialog.message.type == 6"
                            class="msg type-3"
                        >
                            <div class="fs12 black-8 mb8">{{$t('c.Im.text8')}}</div>
                            <div class="flex-box">
                                <pic
                                    :src="dialog.message.content.group.cover"
                                    type="5"
                                    width="96"
                                    height="96"
                                    class="mr16 flex-shrink-0 group-cover"
                                ></pic>
                                <div class="flex-item-1">
                                    <div class="fs20 fwb mb4">
                                        {{ dialog.message.content.group.title }}
                                    </div>
                                    <pre-box
                                        class="fs14 black-4"
                                        :n="30"
                                        :text="
                                            dialog.message.content.group.centent
                                        "
                                    ></pre-box>
                                    <div
                                        class="flex-box flex-direction-row-reverfse"
                                    >
                                        <span
                                            class="mt8 purple fs14"
                                            @click="$mixin_router_push(`/group/${dialog.message.content.group.group_id}`)"
                                            >{{$t('c.Im.text9')}}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <!--<div class="flex-box flex-center black-3 mt-32-16 mq"  v-html="time_diff_list[k]"></div>-->
                </template>
            </div>
            <div
                v-if="has_load && dialog_current.length == 0"
                class="flex-box flex-center w100 black-5"
            >
                {{$t('c.Im.text10')}}
            </div>
        </div>
        <div class="message-edit-box">
            <qa v-if="this_user && session_user && this_user.user_id" :user_id="this_user.user_id" @send_qa_success="send_qa_success"/>
            <textarea-autosize
                class="gl-textarea message-textarea fs16 pre-line"
                v-model="msg"
                :placeholder="$t('c.Im.text11')"
                :min-height="init_height"
                :max-height="max_height"
                @keydown.native.enter="keydown"
                @keypress.native.enter="keypress"
                @blur.native="blur"
                @focus.native="focus"
                :enterkeyhint="'send'"
            ></textarea-autosize>
            <btn class="mq mb-24-0" @click.native="send">{{$t('c.Im.text12')}}</btn>
        </div>
    </div>
</template>

<script>
import { POST_MESSAGE_SEND, GET_MESSAGE_MESSAGES} from "@/api/config";
import { mapState } from "vuex";
export default {
    name: "im",
    data() {
      return {
          msg: this.$route.query && this.$route.query.text ? decodeURIComponent(this.$route.query.text) : '',
          keydown_msg: "",
          user_id: this.$route.params.userId,
          go: null,
          history_has_more: 1,
          has_load: false,
          time_diff: 60 * 30,
      };
    },
    computed: {
        ...mapState("app", ["session_user", "browser_size"]),
        ...mapState("message", ["dialog_current"]),
        ...mapState("user", ["this_user"]),

        init_height() {
            return this.browser_size == "small" ? 56 : 80;
        },
        max_height() {
            return this.browser_size == "small" ? 100 : 200;
        },
        oldest_msg_id() {
            return this.dialog_current.length > 0
                ? this.dialog_current[0].message.msg_id
                : "";
        },
        // is_ignore_user(){
        //     return this.session_user && ['27f7cea2370d11e8ae8852540025c377'].indexOf(this.session_user.user_id) != -1;
        // },
        newest_msg_id() {
            return this.dialog_current.length > 0
                ? this.dialog_current[this.dialog_current.length - 1].message.msg_id
                : "";
        },
        time_diff_list() {
            if (this.dialog_current.length == 1) {
                arr.push(this.dialog_current[0].send_time);
            } else if (this.dialog_current.length > 1) {
                let arr = [];
                this.dialog_current.forEach((v, k) => {
                    if (k < this.dialog_current.length) {
                        arr.push(
                            this.dialog_current[k + 1].send_time -
                                this.dialog_current[k].send_time
                        );
                    }
                });
                return arr;
            }
            return [];
        },
    },
    watch: {
        dialog_current() {
            this.$bus.$emit("POLL_CHECK");
        },
    },
    async beforeMount() {
      if(this.msg && (/Uallen_Qbit/gi).test(this.msg)){
        this.$router.replace({ path: '/a/Uallen_Qbit' })
        return false;
      }
      this.$store.dispatch("user/get:this_user", { user_id: this.user_id });
    },
    async mounted() {
        await this.$store.dispatch("message/get:dialog_current", {
            user_id: this.user_id,
            type: "old",
            message_id: "",
        });
        this.has_load = true;
        setTimeout(() => {
            this.set_height();
            this.$bus.$on("WINDOW_RESIZE", () => {
                this.set_height();
            });
            this.poll();
            this.scroll_to_bottom();
        }, 20);

        setTimeout(() => {
            if (this.$refs.scroll) {
                // window.abc = this.$refs.scroll
                this.$refs.scroll.addEventListener(
                    "scroll",
                    this.throttle(() => {
                        if (this.$refs.scroll.scrollTop < 2500) {
                            this.get_history_msg();
                        }
                    }, 300),
                    false
                );
            }
        }, 1000);
        // document.addEventListener('click', )
    },
    beforeDestroy() {
        this.clear();
        this.$store.dispatch("message/reset:dialog_current");
        this.$bus.$off("WINDOW_RESIZE");
    },
    methods: {
        diff_time(time_before, time_after) {
            return time_after - time_before > 60 * 30 ? time_after : "";
        },
        deal_msg(msg, is_ignore = false) {
            if(is_ignore){
                return msg
            }
            let html = "";
            html = this.$escape_html(msg);
            html = this.$find_url(html, 'afd-im-href=1');
            html = this.$nl2br(html);
            return html;
        },
        throttle(fn, delay) {
            var timer = null;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    fn.apply(context, args);
                }, delay);
            };
        },
        scroll_to_bottom() {
            if (!this.$refs.scroll) {
                return false;
            }

            // this.$refs.scroll.scrollTop = this.$refs.scroll.scrollHeight;
            this.$refs.scroll.scrollTop = 9999999999999 + 150;
        },
        set_height() {
            let h = document.body.clientHeight - this.$el.offsetTop;
            this.$el.style.height = `${h}px`;
        },
        poll() {
            this.clear();
            this.go = setInterval(() => {
                this.check_new_msg();
            }, 1000 * 10);
        },
        clear() {
            if (this.go) {
                clearInterval(this.go);
                this.go = null;
            }
        },
        jump(dialog){
          if(dialog.message.sender == this.session_user.user_id){
            this.$mixin_router_push(`/dashboard/order`)
          }else{
            if(this.browser_size == 'small'){
              this.$mixin_router_push(`/search?q=${dialog.message.content.out_trade_no}&search_type=order&search_param_type=order_id`)
            }
            if(this.browser_size != 'small'){
              this.$mixin_router_push(`/dashboard/sponsored-bill?search_q=${dialog.message.content.out_trade_no}&search_param_type=order_id`)
            }
          } 
        },
        async get_history_msg() {
            //拉取历史记录
            if (!this.history_has_more || this.$http.is_run(GET_MESSAGE_MESSAGES)) {
                return false;
            }
            let data = await this.$http.$axios(GET_MESSAGE_MESSAGES, {
                user_id: this.user_id,
                type: "old",
                message_id: this.oldest_msg_id,
            });
            let list = data.data.list;
            if (data.ec == 200) {
                this.history_has_more = data.data.has_more;
            }
            if (data.ec == 200 && list.length > 0) {
                this.$store.dispatch("message/unconcat:dialog_current", list);
            }
        },
        async check_new_msg() {
            //检查新消息
            let data = await this.$http.$axios(GET_MESSAGE_MESSAGES, {
                user_id: this.user_id,
                type: "new",
                message_id: this.newest_msg_id,
            });
            let list = data.data.list;
            if (data.ec == 200 && list.length > 0) {
                this.$store.dispatch("message/concat:dialog_current", list);
            }
        },
        // async send_lain_msg(data){
        //     this.msg = data.content;
        //     this.send();
        // },
        async send_qa_success(){
            await this.check_new_msg();
            this.$nextTick(() => {
              setTimeout(() => {
                this.scroll_to_bottom();
              },30)
            });
        },
        async send() {
            //发送消息
            if (this.msg != "") {
                if (this.$http.is_run(POST_MESSAGE_SEND)) {
                    return false;
                }
                let data = await this.$http.$axios(POST_MESSAGE_SEND, {
                    user_id: this.user_id,
                    type: "1",
                    content: this.msg,
                });
                if (data.ec != 200) {
                    this.$notify({
                        title: data.em,
                        group: "error",
                    });
                    return false;
                }
                if (data.ec == 200) {
                    this.$store.dispatch(
                        "message/concat:dialog_current",
                        data.data
                    );
                    this.msg = "";
                    this.$nextTick(() => {
                        this.scroll_to_bottom();
                    });
                }
            }
        },
        open_order(msg_id){
            if(this.session_user && this.session_user.is_verified == 1 && this.session_user.verified_type == 1){
                this.$modal.show(
                    () => import("@/components/ModalMsgOrder"),{
                        msg_id,
                    },
                    {
                        pivotY: 0.5,
                        classes: "v--modal-msg-order v--modal",
                        height: "auto",
                        width: 200,
                        adaptive: false,
                        scrollable: true,
                    }
                );
            }
        },
        keydown(e) {
            this.keydown_msg = this.msg;
        },
        keypress(e) {
            if (this.keydown_msg == this.msg && !e.shiftKey) {
                this.send();
                e.preventDefault();
            }
        },
        blur() {
            if (!this.GL.ENV.is_afd_client) {
                return false;
            }
        },
        focus() {
            if (!this.GL.ENV.is_afd_client) {
                return false;
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-im{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height:70vh;

  .message-box {
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 150px;
    box-sizing:border-box;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .scroll-inner-box {
    padding-bottom: 50px;
    // padding-top: 32px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .message-item {
    margin-top: 34px;
    display: flex;
    align-items: flex-start;
    position: relative;

    &:first-child {
      margin-top: 0;
    }
  }

  .receive-box {
    .msg {
      margin-left: 16px;
    }
  }

  .send-box {
    flex-direction: row-reverse;

    .msg {
      background-color: $white;
      margin-right: 16px;
    }
    .send-time{
      right:64px;
      left:auto;
    }
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 1000px;
    background-color: $black-1;
    flex-shrink: 0;
  }
  .send-time{
      position:absolute;
      left:64px;
      top: -16px;
  }

  .group-cover {
    border-radius: 4px;
    overflow: hidden;

    img {
      border-radius: 4px;
    }
  }

  .msg {
    max-width: 380px;
    border-radius: 4px;
    padding: 8px 16px;
    background-color: $black-03;
    border: 1px solid $black-1;
    word-break: break-word;

    &.type-3 {
      width: 375px;
      box-sizing: border-box;

      .vm-pic {
        width: 96px;
        height: 96px;
      }
    }

    &.type-2 {
      color: $white;
      border: 0;
      padding: 0;
      box-shadow: $layer-box-shadow;
      width: 100%;

      &.is-has-remark {
        .leave-info {
          border-radius: 4px 4px 0 0;
        }
      }

      .leave-info {
        background: linear-gradient(90deg, $green, $green-deep);
        padding: 24px 16px;
        border-radius: 4px;
      }

      .leave-word {
        padding: 8px 16px;
        background: $white;
        border-radius: 0 0 4px 4px;
      }
    }
  }

  .message-edit-box {
    border-top: 1px solid $black-1;
    display: flex;
    box-sizing: border-box;
    position:fixed;
    left:50%;
    width:640px;
    box-sizing:border-box;
    bottom:0;
    background:$white-bg;
    transform:translateX(-500px);
    padding:8px 8px 48px 8px;
  }

  .message-textarea {
    border-width: 0;
    padding-left: 0;
  }

  .vm-btn {
    align-self: flex-end;
  }
  .vm-qa /deep/{
    position:absolute;
    right:0;
    left:0;
    transform: translateY(-100%);
    .qa-btn{
      border-top-width:0;
      background: #f7f7f7;
      justify-content: flex-end;
    }
  }
  @media (max-width: $width-mobile) {
    height:108vh;

    .message-item {
    //   margin-top: px2rem(16);
    }

    .message-edit-box {
    //   padding-bottom: 16px;
        width:100%;
        transform:translateX(0);
        left:0;
        padding:8px 8px 16px 8px;
        background:$white;
    }
    .scroll-inner-box {
        padding-bottom: 131px;
    }


    .message-box {
      padding-top: 32px;
    }
    .vm-qa /deep/{
        // left:_px2rem(16);
        top:0;
        width:100vw;
        .qa-btn{
            border-top-width:1px;
            background: $white;
            justify-content: center;
        }
    }

    // .scroll-inner-box {
    //   padding: px2rem(16) 0;
    // }
  }
}
</style>
